import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const VerificationCodeReceiveSchema = T.Object({
  // TODO: Rename to 'identifier' - this field accepts email, registration (matrícula), or phone number
  email: T.String({ minLength: 1, maxLength: 80, error: 'identificador inválido' }),
  isFirstAccess: T.Optional(T.Boolean()),
  // Tenant slug for multi-tenant user lookup (required to avoid cross-tenant conflicts)
  tenantSlug: T.Optional(T.String({ minLength: 1, maxLength: 50 })),
});

export type VerificationCodeReceiveInputType = typeof VerificationCodeReceiveSchema.static;

export async function ValidateVerificationCodeReceiveInput(value: unknown): Promise<VerificationCodeReceiveInputType> {
  return Value.Parse(VerificationCodeReceiveSchema, value);
}

export function checkVerificationCodeReceiveInput(field: string, value: unknown): string | boolean {
  const baseValidation = validateField(VerificationCodeReceiveSchema, field, value);

  if (baseValidation !== true) {
    return baseValidation;
  }

  // Se o valor parece ser um email, validar formato de email
  if (typeof value === 'string' && value.includes('@')) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return 'Formato de e-mail inválido';
    }
  }

  return true;
}
